import type { IconProps } from './typesIcons'

export default function IconHasClube({
  height = 24,
  width = 25,
  className,
}: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 25 24"
      fill="none"
      className={className}
    >
      <path
        d="M12.729 2C18.252 2 22.729 6.477 22.729 12C22.729 17.523 18.252 22 12.729 22C7.206 22 2.729 17.523 2.729 12C2.729 6.477 7.206 2 12.729 2ZM12.729 4C8.31073 4 4.729 7.58172 4.729 12C4.729 16.4183 8.31073 20 12.729 20C17.1473 20 20.729 16.4183 20.729 12C20.729 7.58172 17.1473 4 12.729 4ZM18.8032 8.92871L11.7319 16L7.48877 11.7568L8.90283 10.3428L11.7319 13.1719L17.3882 7.51465L18.8032 8.92871Z"
        fill="#3643BA"
      />
    </svg>
  )
}
